var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-text"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.ptitle))]),_vm._l((_vm.plist),function(p,i){return _c('p',{key:i,staticClass:"text"},[_vm._v(_vm._s(p))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }